import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts, relacionamentos } from '../../../settings';
import { DelayLink, SliderText } from '../../../components';

import './MercadoDeCapitais.scss';

class MercadoDeCapitais extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>IMK (Iniciativa Mercado de Capitais) - Iniciativas - {texts.title}</title>
        </Helmet>

        <div
          className="iniciativas-home mercado-de-capitais-home page-gradient page-gradient--yellow bg-gray"
          ref="mercado-de-capitais-home"
        >
          <section className="iniciativas-area mercado-de-capitais-area page--yellow">
            <div className="container container--large">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title title--gray">IMK (Iniciativa Mercado de Capitais)</h1>
                        </div>
                        <div className="card__content__body">
                          <p>
                            Participamos ativamente do grupo criado pelo governo para fomentar o setor. Foram 16 temas
                            discutidos ao longo do ano: a Associação participou em 13 deles e foi relatora de quatro.
                          </p>
                        </div>
                      </div>
                      {/* <div className="card__image">
                        <img src={images.iniciativas.raio_x.capa} />
                      </div> */}
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="mercado-de-capitais-body">
            <div className="container container--large">
              <div className="row">
                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--no-border card--image">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <img src={images.para_o_mercado.grafico_imk} className="grafico_imk" />
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-6">
                  <Fade bottom>
                    <div className="card card--no-border card--topics">
                      <div className="card__content card__content--full">
                        <div className="card__content__body">
                          <h3 className="title yellow">Confira os assuntos sob nossa liderança:</h3>

                          <p>
                            <strong>Fundos imobiliários:</strong> enviada proposta para modernização da Lei 8.668 para
                            dar clareza às regras e, com isso, reduzir as dificuldades operacionais dos prestadores de
                            serviço que atuam nesse mercado.
                          </p>

                          <p>
                            <strong>Investidores não residentes:</strong> pedimos o esclarecimento do regime de
                            tributação do investidor e foi sugerida a exclusão do limite de 40% de concentração de um
                            mesmo investidor no FIP (Fundo de Investimento em Participações) para harmonizá-lo com os
                            demais fundos e potencializar o investimento estrangeiro de longo prazo na economia.
                          </p>

                          <p>
                            <strong>ETF de renda fixa:</strong> para aprimorar o produto, a sugestão foi de harmonizar a
                            base de cálculo do imposto de renda nos mercados primário e secundário.
                          </p>

                          <p>
                            <strong>Financiamento de pequenas e médias empresas:</strong> encaminhamos proposta para
                            alterar a Lei 6.404 buscando reduzir os custos na emissão de debêntures. Também foi enviada
                            sugestão para criar uma lei específica para a nota comercial, desvinculando-a das notas
                            promissórias emitidas em papel físico.
                          </p>

                          <p>
                            <DelayLink to="/relacionamentos" className="text_link text_link--yellow">
                              Saiba mais sobre a IMK
                            </DelayLink>
                          </p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { MercadoDeCapitais };
